<template>
  <div class="container-fluid">
    <div class="row no-gutters shadow">
      <div class="col-lg-6 img-container">
        <img src="../../src/assets/Image 12.png" class="img-fluid" />
      </div>

      <div class="col-lg-6 secondCol">
        <h1 class="title">Darmowy Ebook</h1>
        <p class="form-desc">
          <strong>
            Poradnik jak prawidłowo sporządzić <br />
            rachunek przepływów pieniężnych
          </strong>
        </p>
        <form @submit.prevent="handleSendEmail" class="form shadow box">
          <p class="form-title text-center">Zaoszczędź czas i pieniądze!</p>
          <p class="text-center">
            Przedstawiam sposób jak szybko i prawidłowo sporządzić Rachunek
            przepływów pieniężnych
          </p>
          <label for="name">Twoje imię</label>
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              id="name"
              aria-describedby="basic-addon3"
              placeholder="Podaj imię"
            />
          </div>
          <label for="email">Twój email</label>
          <div class="input-group mb-3">
            <input
              id="email"
              v-model="email"
              v-validate="'required'"
              type="text"
              class="form-control"
              name="email"
              placeholder="Podaj email"
            />
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              required
              :checked="checkbox"
              v-model="checkbox"
              class="form-check-input"
            />
            <label class="form-check-label" style="font-size:0.6rem;"
              >Wyrażam zgodę na przetwarzanie moich danych osobowych <br />
              zgodnie z ustawą o ochronie danych osobowych</label
            >
          </div>
          <div v-if="emptyEmail" class="alert alert-danger" role="alert">
            Email jest wymagany
          </div>
          <div class="text-right">
            <button
              type="submit"
              :disabled="loading"
              class="mt-4 btn btn-yellow "
            >
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              <span class="btn-yellow-inner" style="font-weight:bold;"
                >CHCĘ EBOOKA</span
              >
            </button>
          </div>
          <div v-if="message == 200" class="alert alert-success" role="alert">
            Email został wysłany
          </div>
          <div v-else-if="message" class="alert alert-danger" role="alert">
            {{ message.message }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: "Ebook",
  data() {
    return {
      email: "",
      loading: false,
      message: "",
      checkbox: false,
      emptyEmail: false,
    };
  },
  methods: {
    handleSendEmail() {
      if (this.checkbox) {
        this.loading = true;
        this.$validator.validateAll().then((isValid) => {
          if (!isValid) {
            this.loading = false;
            this.emptyEmail = true;
            setTimeout(() => (this.emptyEmail = false), 2000);
            return;
          }

          UserService.getSendEmailEbook(this.email).then(
            (response) => {
              this.message = response.status;
              setTimeout(() => (this.message = ""), 2000);
            },
            (error) => {
              this.message =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
              setTimeout(() => (this.message = ""), 2000);
            }
          );
          this.loading = false;
          this.email = "";
          this.message = "";
          this.checkbox = false;
        });
      }
    },
  },
};
</script>

<style scoped>
@import "../assets/css/main.css";
.title {
  margin: 60px 0;
  font-size: 30px;
  text-align: center;
}
.text-center{
  text-align: center;
}
.container-fluid {
  padding: 0;
}
label {
  font-size: 0.75rem;
  font-weight: bold;
}
@media only screen and (max-width: 520px) {
  .box {
    width: 100%;
  }
}
</style>
